import React, { Component } from "react";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {Editor} from "@tinymce/tinymce-react";
// import 'tinymce'
// import 'tinymce/themes/silver'
// const tinyMCEJs = require('tinymce/tinymce.min.js')
// TinyMCE so the global var exists
// eslint-disable-next-line no-unused-vars
import tinymce from 'tinymce/tinymce';

// Theme
import 'tinymce/themes/silver';
// Toolbar icons
import 'tinymce/icons/default';
// Editor styles
import 'tinymce/skins/ui/oxide/skin.min.css';

// importing the plugin js.
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/link';
import 'tinymce/plugins/image';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/table';
import 'tinymce/plugins/template';
import 'tinymce/plugins/help';
import 'tinymce/plugins/print';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/contextmenu';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/textpattern';

// Content styles, including inline UI like fake cursors
/* eslint import/no-webpack-loader-syntax: off */
// import contentCss from '!!raw-loader!tinymce/skins/content/default/content.min.css';
// import contentUiCss from '!!raw-loader!tinymce/skins/ui/oxide/content.min.css';


const TINY_MCE_DEMO_PLUGINS = [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount'
]
const TINY_MCE_PLUGINS = [
    "advlist autolink link image lists charmap print preview hr anchor pagebreak",
    "searchreplace visualblocks visualchars code media nonbreaking",
    "table contextmenu template textcolor paste textcolor colorpicker textpattern"
]
const TINY_MCE_DEMO_TOOLBAR = 'undo redo | formatselect | ' +
    'bold italic backcolor | alignleft aligncenter ' +
    'alignright alignjustify | bullist numlist outdent indent | ' +
    'removeformat | help'
const TINY_MCE_TOOLBAR = "searchreplace | styleselect fontselect fontsizeselect | " +
    "bold italic underline strikethrough";
const TINY_MCE_TOOLBAR2 = "alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | " +
    "link image | table | code"

class ClassicText extends Component {

  constructor(props) {
      super(props);
      this.state = {initialValue: props.value};
      this.editorRef = React.createRef()
  }
  render() {
    return (
        <Editor
            ref = {this.editorRef}
            onInit={(evt, editor) => this.editorRef.current = editor}
            initialValue={this.state.initialValue}
            // tinymceScriptSrc={'tinymce/tinymce.min.js'}
            value={this.props.value}
            onEditorChange={(value, editor) => this.props.onEditorChange(value)}
            init={{
                // theme: false,
                height: 500,
                menubar: true,
                plugins: TINY_MCE_PLUGINS,
                toolbar1: TINY_MCE_TOOLBAR,
                toolbar2: TINY_MCE_TOOLBAR2,
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}
        />
    );
  }
}

export default ClassicText;
